import React, { useState } from 'react'
import Spiner from '../../components/Spiner'
import FunctionsLogic from '../../functions/logic/FunctionsLogic'
import { useSnackbar } from 'notistack'
import t from '../../translations/i18n'

export default function Contact() {
  const [spiner, setSpiner] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [phone, setPhone] = useState('')
  const [value, setValue] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [asunto, setAsunto] = useState('')

  const handleChangeNumber = (e) => {
    const value = e.target.value
    const regex = /^[0-9]*$/
    if (regex.test(value) && value.length <= 10) {
      setPhone(value)
    }
  }

  const handleChangeLetters = (e) => {
    const newValue = e.target.value
    const regex = /^[A-Za-z\s]*$/
    if (regex.test(newValue)) {
      setValue(newValue)
    }
  }

  const handledSend = async (event) => {
    setSpiner(true)
    event.preventDefault()

    const response = await FunctionsLogic.sendRequest(event.target)
    setSpiner(false)

    enqueueSnackbar(response.message, {
      variant: response.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    if (!response.error) {
      setPhone('')
      setValue('')
      setEmail('')
      setSubject('')
      setAsunto('')
    }
  }

  return (
    <>
      {' '}
      <Spiner opt={spiner} loadLabel={global.LOAD_LABEL_SEND} />
      <section id="contact" className="contact">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('sections.contact_tittle')}</h2>
            <p>{t('sections.contact_subtittle')}</p>
          </div>

          <div className="row">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="info">
                <div className="address">
                  <i className="bi bi-geo-alt"></i>
                  <div>
                    <h4>{t('sections.contact_dirt')}</h4>
                    <p>{t('sections.contact_dirs')}</p>
                  </div>
                </div>

                <div className="email">
                  <i className="bi bi-envelope"></i>
                  <div>
                    <h4>{t('sections.contact_emailt')}</h4>
                    <p>{t('sections.contact_emails')}</p>
                  </div>
                </div>

                <div className="phone">
                  <i className="bi bi-phone"></i>
                  <div>
                    <h4>{t('sections.contact_phonet')}</h4>
                    <p>{t('sections.contact_phgonesu')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <form
                action="/"
                method="POST"
                className="php-email-form"
                onSubmit={(e) => {
                  handledSend(e)
                }}
              >
                <div className="row">
                  <div className="form-group col-md-12">
                    <label htmlFor="name">{t('inputs.names')}</label>
                    <input
                      type="text"
                      onChange={handleChangeLetters}
                      value={value}
                      maxLength={50}
                      name="name"
                      className="form-control"
                      id="name"
                      placeholder={t('inputs.names_ph')}
                    />
                  </div>

                  <div className="form-group col-md-6 mt-3">
                    <label htmlFor="email">{t('inputs.email')}</label>
                    <input
                      type="text"
                      maxLength={50}
                      className="form-control"
                      name="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={t('inputs.email_ph')}
                    />
                  </div>

                  <div className="form-group col-md-6 mt-3">
                    <label htmlFor="phone">{t('inputs.telefono')}</label>
                    <input
                      type="text"
                      onChange={handleChangeNumber}
                      maxLength={10}
                      value={phone}
                      className="form-control"
                      name="phone"
                      id="phone"
                      placeholder={t('inputs.telefono_ph')}
                    />
                  </div>

                  <div className="form-group col-md-12 mt-3">
                    <label htmlFor="subject">{t('inputs.titulo')}</label>
                    <input
                      type="text"
                      maxLength={50}
                      className="form-control"
                      name="subject"
                      id="subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      placeholder={t('inputs.titulo_ph')}
                    />
                  </div>

                  <div className="form-group col-md-12 mt-3">
                    <label htmlFor="asunto">{t('inputs.asunto')}</label>
                    <textarea
                      maxLength={5000}
                      className="form-control"
                      name="asunto"
                      id="asunto"
                      value={asunto}
                      onChange={(e) => setAsunto(e.target.value)}
                      placeholder={t('inputs.asunto_ph')}
                      rows="8"
                    ></textarea>
                  </div>

                  <div className="text-center mt-4">
                    <button type="submit">Enviar Mensaje</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
